import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCup: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCup"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H17V6H21V14H17V21H3V3ZM19 8H17V12H19V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCup;
